import React from 'react';
import { Text } from '@wix/design-system';
import { useTermsAndConditionsText } from './use-terms-and-conditions';
import { withEssentialsContext } from '../../contexts/essentials-context';
import type { ExternalComponentProps } from '../types';

export interface TermsAndConditionsProps extends ExternalComponentProps {
  darkCtas?: boolean;
  appName: string;
  companyName: string;
  termsOfUseUrl?: string;
  privacyPolicyUrl?: string;
  isInstalled: boolean;
  onTermsAndConditionsClick: (link: string) => void;
  onPrivacyPolicyClick: (link: string) => void;
}

const TermsAndConditionsComponent = (props: TermsAndConditionsProps) => {
  const termsAndConditionsText = useTermsAndConditionsText(props);

  return (
    <Text dataHook="terms-and-conditions" size="small" weight="thin">
      {termsAndConditionsText}
    </Text>
  );
};

export const TermsAndConditions = withEssentialsContext(
  TermsAndConditionsComponent,
);
